// DoneActions.tsx
import CommonButtons from "../../../../../shared/components/CommonButtons";
import Print from "../../../../../printConfigration/PrintConfigration";

interface Props {
  onSendMail: () => void;
  onSendMessage: () => void;
  onDone: () => void;
  printData: any;
  osb: number | string;
  disabled?: boolean; // new prop
}

export default function DoneActions({ onSendMail, onSendMessage, onDone, printData, osb, disabled = false }: Props) {
  return (
    <div className="flex justify-center space-x-4 mt-6 opacity-100">
      <CommonButtons label="Send Mail" className="px-2" onClick={onSendMail} disabled={disabled} />
      <CommonButtons label="Send Message" className="px-2" onClick={onSendMessage} disabled={disabled} />
      <div onClick={!disabled ? onDone : undefined}>
        <Print
          PrintData={{ ...printData, Paid: printData.Paid ?? 0, OSB: osb || 0 }}
          BtnName="Done"
          className="w-40 rounded-full"
        />
      </div>
    </div>
  );
}
